import { createAppSlice } from '../../app/createAppSlice';

const initialState = {
    count: 1,
    foi: ""
};

const m11StepCountSlice = createAppSlice({
    name: "m11StepCount",
    initialState,
    reducers: create => ({
        m11StepCountUp: create.reducer((state) => {
            state.count = state.count + 1;
            //const url = "/m11report/" + state.foi + "/step/" + state.count;
            //window.history.pushState({ urlPath: url }, "", url);
        }),
        m11StepCountDown: create.reducer((state) => {
            state.count = state.count - 1;
            //const url = "/m11report/" + state.foi + "/step/" + state.count;
            //window.history.pushState({ urlPath: url }, "", url);
        }),
        goToM11Step: create.reducer((state, action) => {
            state.count = action.payload;
            //const url = "/m11report/" + state.foi + "/step/" + state.count;
            //window.history.pushState({ urlPath: url }, "", url);

        }),
        m11ResearchStudyFoiChanged: create.reducer((state, action) => {
            state.foi = action.payload
        })
    }),
    selectors: {
        selectM11StepCount: m11StepCount => m11StepCount.count,
        selectM11ResearchStudyFoi: m11StepCount => m11StepCount.foi
    },
})

export const { m11StepCountUp, m11StepCountDown, goToM11Step, m11ResearchStudyFoiChanged } = m11StepCountSlice.actions

export const { selectM11StepCount, selectM11ResearchStudyFoi } = m11StepCountSlice.selectors

export default m11StepCountSlice